"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Option = void 0;
var react_1 = __importDefault(require("react"));
var focus_1 = require("@react-aria/focus");
var listbox_1 = require("@react-aria/listbox");
var utils_1 = require("@react-aria/utils");
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var check_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/check.icon.svg"));
var SelectContext_1 = require("../../context/SelectContext");
var Option_module_scss_1 = __importDefault(require("./Option.module.scss"));
var Option = function (_a) {
    var item = _a.item, classNameOverride = _a.classNameOverride, props = __rest(_a, ["item", "classNameOverride"]);
    var ref = react_1["default"].useRef(null);
    var state = (0, SelectContext_1.useSelectContext)().state;
    var _b = (0, listbox_1.useOption)({ key: item.key }, state, ref), optionProps = _b.optionProps, isSelected = _b.isSelected, isDisabled = _b.isDisabled;
    var _c = (0, focus_1.useFocusRing)(), isFocusVisible = _c.isFocusVisible, focusProps = _c.focusProps;
    return (react_1["default"].createElement("li", __assign({}, (0, utils_1.mergeProps)(optionProps, focusProps, props), { ref: ref, className: (0, classnames_1["default"])(Option_module_scss_1["default"].option, isSelected && Option_module_scss_1["default"].isSelected, isFocusVisible && Option_module_scss_1["default"].isFocusVisible, isDisabled && Option_module_scss_1["default"].disabled, classNameOverride), "aria-label": item.textValue }),
        item.rendered,
        react_1["default"].createElement("span", { className: (0, classnames_1["default"])(Option_module_scss_1["default"].icon, isSelected && Option_module_scss_1["default"].isSelected) }, isSelected && react_1["default"].createElement(component_library_1.Icon, { icon: check_icon_svg_1["default"], role: "presentation" }))));
};
exports.Option = Option;
exports.Option.displayName = "Option";
//# sourceMappingURL=Option.js.map